import React, { useState, useRef, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { useAuth } from '../../hooks/useApi';

const AuthToggle = styled.div`
  position: relative;
  
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  z-index: 10;
`;

const ToggleText = styled.span`
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  margin-right: 8px;
`;

const ToggleButton = styled.button`
  background: none;
  border: none;
  color: #FFD700;
  cursor: pointer;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  
  &:hover {
    color: #FF8C00;
    text-decoration: underline;
  }
`;

const ForgotPasswordLink = styled.button`
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  font-size: 13px;
  text-decoration: none;
  margin-top: 12px;
  transition: all 0.3s ease;
  
  &:hover {
    color: #FFD700;
    text-decoration: underline;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const sparkle = keyframes`
  0%, 100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
`;
    // background-image: radial-gradient(circle at 20% 80%, rgba(0, 215, 255, 0.1) 0%, transparent 50%),
    //                   radial-gradient(circle at 80% 20%, rgba(0, 140, 255, 0.1) 0%, transparent 50%),
    //                   radial-gradient(circle at 40% 40%, rgba(138, 43, 226, 0.1) 0%, transparent 50%);
const AuthPageContainer = styled.div`
  min-height: 100vh;
  background: black;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  position: relative;
  overflow: hidden;
  overflow-x: hidden;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 1rem;
  }

  @media (max-width: 480px) {
    padding: 0.75rem;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: radial-gradient(circle at 20% 80%, rgba(0, 0, 0, 0.1) 0%, transparent 50%),
                      radial-gradient(circle at 80% 20%, rgba(0, 0, 0, 0.1) 0%, transparent 50%),
                      radial-gradient(circle at 40% 40%, rgba(0, 0, 0, 0.1) 0%, transparent 50%);
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: radial-gradient(circle at 2% 4%, rgba(255, 255, 255, 0.26) 1px, transparent 0),
                      radial-gradient(circle at 29% 36%, rgba(255, 255, 255, 0.32) 1px, transparent 0),
                      radial-gradient(circle at 50% 60%, rgba(255, 255, 255, 0.2) 1px, transparent 0),
                      radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.66) 1px, transparent 0),
                      radial-gradient(circle at 70% 10%, rgba(255, 255, 255, 0.11) 1px, transparent 0),
                      radial-gradient(circle at 60% 12%, rgba(255, 255, 255, 0.29) 1px, transparent 0),
                      radial-gradient(circle at 43% 90%, rgba(255, 255, 255, 0.51) 1px, transparent 0),
                      radial-gradient(circle at 32% 83%, rgba(255, 255, 255, 0.16) 1px, transparent 0),
                      radial-gradient(circle at 49% 53%, rgba(255, 255, 255, 0.6) 1px, transparent 0),
                      radial-gradient(circle at 89% 52%, rgba(255, 255, 255, 0.14) 1px, transparent 0);

    
    background-size: 25% 25%;
    pointer-events: none;
    background-repeat: repeat;
    animation: ${sparkle} 4s ease-in-out infinite;

  }
`;

const AuthCard = styled.div`
  
  background: rgba(30, 30, 30, 0.1);
  border: 2px solid linear-gradient(135deg, #FFD700 0%, #FF8C00 100%);
 
  border-radius: 20px;
  padding: 40px;
  max-width: 450px;
  width: 100%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3), 
              0 0 0 1px rgba(0, 215, 255, 0.1),
              inset 0 1px 0 rgba(255, 255, 255, 0.1);
  
  animation: ${fadeIn} 0.6s ease-out;
  position: relative;
  z-index: 1;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 2rem;
    max-width: 100%;
  }

  @media (max-width: 480px) {
    padding: 1.5rem;
    border-radius: 16px;
  }

  @media (max-width: 360px) {
    padding: 1rem;
  }
`;

const TabContainer = styled.div`
  display: flex;
  margin-bottom: 30px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 4px;
`;

const Tab = styled.button`
  flex: 1;
  padding: 12px 20px;
  background: ${props => props.active ? 'linear-gradient(135deg, #FFD700 0%, #FF8C00 100%)' : 'transparent'};
  color: ${props => props.active ? '#000' : 'rgba(255, 255, 255, 0.7)'};
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;

  &:hover {
    color: ${props => props.active ? '#000' : '#FFD700'};
  }
`;

const LogoSection = styled.div`
  text-align: center;
  margin-bottom: 40px;
`;

// const LogoIcon = styled.div`
//   width: 80px;
//   height: 80px;
//   margin: 0 auto 20px;
//   position: relative;
//   background: linear-gradient(135deg, #FFD700 0%, #FF8C00 50%, #FF6B35 100%);
//   border-radius: 15px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   box-shadow: 0 10px 30px rgba(255, 215, 0, 0.3);

//   &::before {
//     content: 'GG';
//     font-size: 28px;
//     font-weight: bold;
//     color: #000;
//     text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
//   }

//   &::after {
//     content: '';
//     position: absolute;
//     bottom: -8px;
//     left: 50%;
//     transform: translateX(-50%);
//     width: 40px;
//     height: 12px;
//     background: linear-gradient(135deg, #FFD700 0%, #FF8C00 100%);
//     border-radius: 6px;
//   }
// `;

const LogoIcon = () => (
<img src="images/logofull.svg" alt="Logo" style={{ height: '256px'}} />
);

const BrandTitle = styled.h1`
  font-size: clamp(1.5rem, 5vw, 28px);
  font-weight: 700;
  color: #fff;
  margin: 0 0 8px 0;
  background: linear-gradient(135deg, #FFD700 0%, #FF8C00 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

const BrandSubtitle = styled.p`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0 0 30px 0;
  text-transform: uppercase;
  letter-spacing: 2px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const InputGroup = styled.div`
  position: relative;
`;

const Input = styled.input`
  width: 100%;
  padding: 16px 20px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: #fff;
  font-size: clamp(14px, 2.5vw, 16px);
  transition: all 0.3s ease;
  box-sizing: border-box;
  min-height: 44px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }

  &:focus {
    outline: none;
    border-color: #667eea;
    background: rgba(255, 255, 255, 0.08);
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
  }

  &:hover {
    border-color: rgba(102, 126, 234, 0.3);
  }

  @media (max-width: 480px) {
    padding: 12px 16px;
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: clamp(14px, 2.5vw, 16px);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;

  min-height: 44px;
  box-sizing: border-box;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  @media (max-width: 480px) {
    padding: 12px;
  }
`;

const Error = styled.div`
  color: #ff6b6b;
  font-size: 14px;
  padding: 12px 16px;
  background: rgba(255, 107, 107, 0.1);
  border: 1px solid rgba(255, 107, 107, 0.2);
  border-radius: 8px;
  margin-top: 10px;
`;

const Success = styled.div`
  color: #51cf66;
  font-size: 14px;
  padding: 12px 16px;
  background: rgba(81, 207, 102, 0.1);
  border: 1px solid rgba(81, 207, 102, 0.2);
  border-radius: 8px;
  margin-top: 10px;
`;

const AchievementMessage = styled.div`
  text-align: center;
  margin-bottom: 30px;
  color: rgba(255, 255, 255, 0.8);
  font-style: italic;
`;

const PasswordInputWrapper = styled.div`
  position: relative;
`;

const PasswordToggleButton = styled.button`
  position: absolute;
  right: 15px;
  top: 3px;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  font-size: 18px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s ease;
  z-index: 2;

  &:hover {
    color: rgba(255, 255, 255, 0.8);
  }
`;

const Login = ({ onLogin, authMode, setAuthMode, onForgotPassword, prefilledUsername }) => {
  const { login } = useAuth();
  const [credentials, setCredentials] = useState({
    identifier: prefilledUsername || '',
    password: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const passwordInputRef = useRef(null);

  // Update username if prefilled value changes and focus password
  useEffect(() => {
    if (prefilledUsername) {
      console.log('🔑 Login prefilled with username:', prefilledUsername);
      setCredentials(prev => ({ ...prev, identifier: prefilledUsername }));
      // Focus password field after a short delay to ensure render is complete
      setTimeout(() => {
        if (passwordInputRef.current) {
          passwordInputRef.current.focus();
          console.log('🎯 Password field focused');
        }
      }, 100);
    }
  }, [prefilledUsername]);

  const sanitizeInput = (value, fieldType = 'general') => {
    if (fieldType === 'email') {
      // Email: allow letters, numbers, @, ., -, _
      return value.replace(/[^A-Za-z0-9@._-]/g, '');
    } else if (fieldType === 'username') {
      // Username: allow letters, numbers, -, _
      return value.replace(/[^A-Za-z0-9_-]/g, '');
    } else if (fieldType === 'password') {
      // Password: allow letters, numbers, and safe special chars (NO < > for XSS protection)
      return value.replace(/[^A-Za-z0-9!@#$%^&*()_+\-=\x5B\x5D{};':"\\|,./?]/g, '');
    }
    // General: remove dangerous characters
    return value.replace(/[<>"'`;\\]/g, '');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let sanitizedValue = value;

    // Sanitize based on field type
    if (name === 'identifier') {
      // Could be email or username, allow both patterns
      sanitizedValue = value.includes('@') 
        ? sanitizeInput(value, 'email')
        : sanitizeInput(value, 'username');
    } else if (name === 'password') {
      sanitizedValue = sanitizeInput(value, 'password');
    }

    setCredentials({
      ...credentials,
      [name]: sanitizedValue
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      console.log('[Login] Form submitted with identifier:', credentials.identifier);
      const response = await login(credentials);
      console.log('[Login] Login successful, response:', response);

      setSuccess('Login successful! Redirecting...');

      // The login function in useAuth has updated state (setUser + setToken)
      // App component should now re-render and show authenticated view
      console.log('[Login] Calling onLogin callback');
      if (onLogin) {
        onLogin(response.user, response.jwt);
      }

      console.log('[Login] Login complete - App should detect isAuthenticated=true and redirect');
    } catch (error) {
      console.error('[Login] Login error:', error);
      const errorMessage = error.response?.data?.error?.message ||
                          error.response?.data?.message ||
                          error.message ||
                          'Login failed. Please check your credentials.';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthPageContainer>
      <AuthCard>
        <LogoSection>
          <LogoIcon />
          <BrandSubtitle>GAMERS REDEMPTION PORTAL</BrandSubtitle>
        </LogoSection>

        <TabContainer>
          <Tab active={authMode === 'login'} onClick={() => setAuthMode('login')}>LOG IN</Tab>
          <Tab active={authMode === 'register'} onClick={() => setAuthMode('register')}>REGISTER</Tab>
        </TabContainer>

        <AchievementMessage>
          Your Achievement is Unlocked.<br />
          Your Rewards Await.
        </AchievementMessage>
        
        <Form onSubmit={handleSubmit}>
          <InputGroup>
            <Input
              type="text"
              name="identifier"
              placeholder="Email or Username"
              value={credentials.identifier}
              onChange={handleChange}
              required
            />
          </InputGroup>
          
          <InputGroup>
            <PasswordInputWrapper>
              <Input
                type={showPassword ? 'text' : 'password'}
                name="password"
                placeholder="Password"
                value={credentials.password}
                onChange={handleChange}
                ref={passwordInputRef}
                required
              />
              <PasswordToggleButton
                type="button"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </PasswordToggleButton>
            </PasswordInputWrapper>
          </InputGroup>
          
          <Button type="submit" disabled={loading}>
            {loading ? 'Logging in...' : 'Log In'}
          </Button>

          {onForgotPassword && (
            <ForgotPasswordLink type="button" onClick={onForgotPassword}>
              Forgot your password?
            </ForgotPasswordLink>
          )}
          
          <AuthToggle>
          {authMode === 'login' ? (
            <>
              <ToggleText>Don't have an account?</ToggleText>
              <ToggleButton onClick={() => setAuthMode('register')}>
                Create Account
              </ToggleButton>
            </>
          ) : (
            <>
              <ToggleText>Already have an account?</ToggleText>
              <ToggleButton onClick={() => setAuthMode('login')}>
                Sign In
              </ToggleButton>
            </>
          )}
        </AuthToggle>
          {error && <Error>{error}</Error>}
          {success && <Success>{success}</Success>}
        </Form>
      </AuthCard>
    </AuthPageContainer>
  );
};

export default Login;